import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { 
    Stack,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Container
} from '@mui/material';

import {
    Info,
    ExpandMore as ExpandMoreIcon
} from '@mui/icons-material';

import { Evaluation } from '../../../App/API/Experiments';

import StudentEvaluationGraph from './StudentEvaluationGraph';

type ShowStudentEvaluationButtonProps = {
    evaluation: Evaluation;
}

export default function ShowStudentEvaluationButton({ evaluation } : ShowStudentEvaluationButtonProps) : JSX.Element
{
    const [ t ] = useTranslation();
    const [ expanded, setExpanded ] = React.useState(false);

    return (
        <Container
        sx= {{
            marginBottom:'2rem'
        }}
        >
            {
            evaluation.length > 0 &&
            <>
                <Typography
                    variant="h6"
                    component="span"
                    align="center"
                    sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '1rem',
                        marginBottom: '1rem',
                    }}
                    >
                        <Info
                        sx= {{
                            marginRight:'0.5rem'
                        }}
                        />{ t('experimentation_view.student_evaluation.evaluation_available') }
                    </Typography>
                <Accordion
                    expanded = { expanded }
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        onClick={ () => setExpanded(!expanded) }
                    >
                        <Typography variant='h6' component='h4'>{ t('experimentation_view.student_evaluation.show') }</Typography>
                    </AccordionSummary>
                    <AccordionDetails
                        sx = {{
                            userSelect: 'none',
                            marginBottom:'2rem'
                        }}
                    >
                        <StudentEvaluationGraph evaluation={evaluation}/>
                        
                        <Stack
                            direction = {{ xs: 'column', sm: 'row' }}
                            justifyContent = "space-between"
                            alignItems = "center"
                            spacing = { 2 }
                        >
                        </Stack>
                    </AccordionDetails>
                </Accordion>
            </>
            }
        </Container>
        
    );
}